import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import './header.css'
import { ExistIcon, SettingIcon } from 'components/icon'
import { Button, MultiButton } from 'components/button'
import { Flex } from 'components/flex'
import { useAuth } from 'AuthProvider'
import { alert, callApi } from 'utils'
//import axios from "axios";
import logo from 'assets/images/logo.svg'

import * as ChannelService from '@channel.io/channel-web-sdk-loader'

const getMemberHash = async () => {
  const postData = {
    opId: sessionStorage.getItem('userId'),
    opeNo: sessionStorage.getItem('opeNo'),
    email: sessionStorage.getItem('email')
  }

  const response = await callApi('api/platform/setChannelTalkHash', postData)

  return response.data
}

const connectionChannelTalk = async (infos) => {
  const memberHash = await getMemberHash()

  const phoneNumber = infos.phoneNumber.replace(/-/g, '').substring(1)

  ChannelService.boot({
    pluginKey: '0c633aa7-f7cb-4b99-aa69-0570db0ee45d', // fill your plugin key,
    memberId: sessionStorage.getItem('userId'),
    memberHash: memberHash,
    profile: {
      chatType: 'hulampro_inquiry',
      name: infos.companyName,
      mobileNumber: `+82${phoneNumber}`,
      email: infos.emailAddress,
      loginType: sessionStorage.getItem('author') === 'manager' ? 'hp_company' : 'hp_employee'
    }
  })

}

export default function Header ({
  isLogin = false
}) {
  const mobileRef = useRef()
  const navRef = useRef()

  ChannelService.loadScript()

  const HomepageHeader = () => {
    const mobileOnOff = () => {
      mobileRef.current.classList.toggle('on')
      navRef.current.classList.toggle('on')
    }

    const mobileOff = () => {
      mobileRef.current.classList.remove('on')
      navRef.current.classList.remove('on')
    }

    ChannelService.boot({
      pluginKey: '0c633aa7-f7cb-4b99-aa69-0570db0ee45d', // fill your plugin key
      profile: {
        chatType: 'hulampro_inquiry',
        loginType: 'guest'
      }
    })

    return (
      <div className="inner">
        <h1 className="logo">
          <Link to="/" onClick={() => mobileOff()}><img src={logo} alt="logo"/></Link>
        </h1>
        <nav ref={navRef}>
          <ul className="menu">
            <li><Link to="/subscriptionFee" onClick={() => mobileOff()}>이용요금</Link></li>
          </ul>
          {/* <div className="service_menu">
            <Link to="/login" style={{ margin: '0 39px' }}>로그인</Link>
            <Link to="/join" className='reg_button'>
              가입하기
            </Link>
          </div> */}
          <MultiButton className={'service_menu'}>
            <Button type="text" href="/login" width={110} onClick={() => mobileOff()}>로그인</Button>
            <Button type="background-purple" href="/join" width={110} onClick={() => mobileOff()}>가입하기</Button>
          </MultiButton>
        </nav>
        <div ref={mobileRef} className="m_menu" onClick={() => mobileOnOff()}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    )
  }

  /**@function ProgramHeader
   * 로그인 O 헤더
   */
  const ProgramHeader = () => {

    const { author, logout, onBoardingClose, setOnBoardingClose, adminlogin } = useAuth()
    const [companyName, setCompanyName] = useState('')
    const [employeeName, setEmployeeName] = useState('')
    const [employeeCount, setEmployeeCount] = useState(0)
    // const navigate = useNavigate();

    // useEffect(() => {
    //   navigate('/operatorCompanyList', { replace: true });
    // }, [adminlogin, navigate])

    useEffect(() => {
      const profileSetting = async () => {

        let sessionStorage = window.sessionStorage
        let opId = sessionStorage.getItem('userId')
        let email = sessionStorage.getItem('email')

        const postData = {
          opId: opId,
          email: email
        }

        if (opId) {

          const response = await callApi('api/platform/viewPrivateSetting', postData)
          if (response && response.result) {
            const { data } = response

            setCompanyName(data.companyName ? data.companyName : '')
            setEmployeeCount(data.employeeCount ? data.employeeCount : 0)
            connectionChannelTalk(data)

          } else if (response === 402) {
            if (author !== 'admin') {
              logout()
            }

          }
        }

      }

      profileSetting()
    }, [logout, author])

    useEffect(() => {
      const getEmployeeInfo = async () => {
        let sessionStorage = window.sessionStorage
        const postData = {
          opId: sessionStorage.getItem('userId'),
          opeNo: sessionStorage.getItem('opeNo'),
          email: sessionStorage.getItem('email')
        }

        const response = await callApi('api/platform/viewPrivateSetting', postData)

        if (response && response.result) {
          setEmployeeName(response.data.employeeName)
        }
      }

      if (author === 'employee') {
        getEmployeeInfo()
      }
    }, [author])

    let sessionStorage = window.sessionStorage
    let adminId = sessionStorage.getItem('adminId')
    let userId = sessionStorage.getItem('userId')
    let adminAccessToken = sessionStorage.getItem('adminAccessToken')

    return <header id="header" className="App-header header shadow">
      <div className="inner authheader ">
        <div className="h_left">
          <div className="header_info" style={{ display: 'flex', alignItems: 'center' }}>
            <em>{companyName}</em>
            {
              author === 'manager' && (
                <>
                  <span>|</span>
                  <Flex>
                    <span className="worker_num">직원수 {employeeCount}명</span>
                  </Flex>
                </>
              )
            }
            {
              author === 'employee' && (
                <>
                  <span>|</span>
                  <Flex>
                    <span className="worker_num">{employeeName}</span>
                  </Flex>
                </>
              )
            }

          </div>
          {/*<div className="info_box" style={{*/}
          {/*  padding: '8px 16px',*/}
          {/*  height: 30,*/}
          {/*  marginLeft: 14,*/}
          {/*  backgroundColor: '#E9F0FE',*/}
          {/*  border: '1px solid #BFD3FA',*/}
          {/*  fontSize: 14,*/}
          {/*  color: '#52545C'*/}
          {/*}}>*/}
          {/*  <i className="svg_icon_20_warning_blue"></i>국민연금 EDI 개편으로 데이터 수집이 불안정할 수 있습니다. <span*/}
          {/*  style={{ textDecoration: 'underline', cursor: 'pointer' }}*/}
          {/*  onClick={() => {*/}
          {/*    window.open('https://shimmer-vein-8d5.notion.site/EDI-1d541e391ec94d2a963a68f478add3bb?pvs=4')*/}
          {/*  }}*/}
          {/*>자세히 보기 ></span>*/}
          {/*</div>*/}
          {window.location.hostname.includes('dev.hulampro.co.kr') || window.location.hostname.includes('localhost') ?
            <div className="info_box" style={{ padding: '8px 16px', height: 30, marginLeft: 14 }}>
              <i className="svg_icon_20_warning"></i>
              <span style={{ color: '#52545C', fontSize: 14, lineHeight: 14 }}>개발 서버</span>
            </div> : null}

        </div>
        <div className="h_right">
          <Flex columnGap={20}>
            {userId !== 'hulampro_admin' && adminId === 'hulampro_admin' && adminAccessToken ?
              <Button
                type="line-gray"
                size="sm"
                style={{ columnGap: 10 }}
                onClick={() => {

                  let sessionStorage = window.sessionStorage
                  let adminId = sessionStorage.getItem('adminId')
                  let adminAccessToken = sessionStorage.getItem('adminAccessToken')

                  let response = {
                    type: 'admin',
                    userId: adminId
                    , access_token: adminAccessToken,
                    adminId, adminAccessToken

                  }

                  const postData = {
                    opId: adminId,
                    userId: adminId
                    // 추가 필드
                  }

                  callApi('api/admin/loginInfo', postData)
                  adminlogin(response)

                  // axios.get('https://geolocation-db.com/json/').then(async (res) => {
                  //   let sessionStorage = window.sessionStorage;
                  //   let adminId = sessionStorage.getItem("adminId");
                  //   let adminAccessToken = sessionStorage.getItem("adminAccessToken");

                  //   let response = {
                  //     type: "admin",
                  //     userId: adminId
                  //     , access_token: adminAccessToken,
                  //     adminId, adminAccessToken

                  //   };

                  //   const postData = {
                  //     opId: adminId,
                  //     userId: adminId,
                  //     ip: res.data.IPv4
                  //     // 추가 필드
                  //   };

                  //   await callApi('api/admin/loginInfo', postData);
                  //   adminlogin(response);
                  // }
                  //);
                }}
              >
                어드민 로그인
              </Button>
              : null}
            {

              (onBoardingClose && author === 'manager') && (
                <Button
                  type="line-gray"
                  size="sm"
                  style={{ columnGap: 10 }}
                  onClick={() => {
                    localStorage.setItem('lookOnboardingCount', '1')
                    setOnBoardingClose(false)
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M8.71549 2.04535C9.09803 1.79537 9.5476 1.66675 9.99571 1.66675C10.4541 1.66675 10.8948 1.79628 11.2759 2.04535C11.6578 2.29489 11.95 2.64737 12.1348 3.04981L12.1366 3.05367L12.596 4.07232C12.6957 4.30393 12.8668 4.49661 13.0891 4.62386L13.0952 4.62738C13.3098 4.75337 13.5653 4.80947 13.8229 4.78163C13.8228 4.78164 13.8229 4.78163 13.8229 4.78163L14.9213 4.662L14.9239 4.66172C15.3845 4.61345 15.8332 4.71112 16.2234 4.90536L16.2367 4.91218C16.635 5.12215 16.9646 5.4381 17.1886 5.82553C17.4156 6.21801 17.5203 6.67467 17.4968 7.11924C17.4732 7.57315 17.3208 8.01009 17.0472 8.37873L16.4023 9.26588C16.2493 9.49107 16.1672 9.74845 16.1672 10.0001C16.1672 10.2618 16.2467 10.5154 16.3987 10.7293C16.3992 10.73 16.3997 10.7307 16.4002 10.7314L17.0472 11.6214C17.3223 11.9921 17.4734 12.4381 17.4968 12.8809C17.5203 13.3255 17.4156 13.7822 17.1886 14.1746C16.9707 14.5515 16.6438 14.8836 16.2301 15.0914C15.8237 15.304 15.3713 15.3853 14.9239 15.3384L14.9213 15.3382L13.8215 15.2184C13.5776 15.1914 13.3207 15.2445 13.0922 15.3745C12.8774 15.5015 12.7017 15.6967 12.592 15.9369L12.1434 16.9504C11.9587 17.3528 11.6664 17.7053 11.2845 17.9548C10.902 18.2048 10.4524 18.3334 10.0043 18.3334C9.54591 18.3334 9.10523 18.2039 8.72408 17.9548C8.34221 17.7053 8.04996 17.3528 7.8652 16.9504L7.86153 16.9424L7.44541 16.0019C7.43453 15.983 7.42454 15.9633 7.41551 15.9429C7.30578 15.6957 7.13134 15.5025 6.91094 15.3763L6.90479 15.3728C6.69031 15.2468 6.43486 15.1907 6.17739 15.2185L5.07871 15.3382L5.07611 15.3384C4.61554 15.3867 4.16678 15.289 3.77664 15.0948L3.76333 15.088C3.36504 14.878 3.0354 14.5621 2.81138 14.1746C2.58452 13.7823 2.47981 13.3258 2.50321 12.8814C2.52727 12.4159 2.69428 11.9841 2.94729 11.6291L2.95076 11.6242L3.59768 10.7343C3.59623 10.7364 3.59478 10.7385 3.59332 10.7407L4.12462 11.1026L3.60313 10.7268L3.59768 10.7343C3.75065 10.5091 3.83278 10.2517 3.83278 10.0001C3.83278 9.72595 3.75119 9.47542 3.6046 9.27538L3.60313 9.27337L2.95283 8.37874C2.95364 8.37984 2.95446 8.38094 2.95527 8.38203L3.47228 8.00008L2.95079 8.37594L2.95283 8.37874C2.6777 8.00807 2.52664 7.56207 2.50323 7.11924C2.47974 6.67467 2.58444 6.21801 2.81138 5.82553C3.02927 5.4487 3.35617 5.11654 3.76991 4.90873C3.76771 4.90988 3.76552 4.91103 3.76333 4.91218L4.06454 5.47871L3.77664 4.90536C3.77439 4.90648 3.77215 4.9076 3.76991 4.90873C4.17629 4.69618 4.62876 4.61483 5.07611 4.66172L5.07871 4.662L6.17849 4.78178C6.42238 4.80876 6.67928 4.75565 6.90785 4.62562C6.90684 4.62622 6.90583 4.62682 6.90481 4.62741L7.23183 5.17957L6.91094 4.62386C6.90991 4.62445 6.90888 4.62503 6.90785 4.62562C7.13055 4.49401 7.30723 4.29731 7.40405 4.07236L7.40664 4.06636L7.85656 3.04978C8.04132 2.64734 8.33362 2.29489 8.71549 2.04535ZM8.55643 15.3455C8.5701 15.3683 8.58248 15.392 8.59344 15.4168L9.03782 16.4209C9.12776 16.6151 9.26403 16.7742 9.43048 16.883C9.59866 16.9929 9.79317 17.0514 10.0043 17.0514C10.2085 17.0514 10.4113 16.992 10.5781 16.883C10.7446 16.7742 10.8808 16.6151 10.9708 16.4209L11.4177 15.4111C11.6336 14.9357 11.9885 14.5342 12.4411 14.2684L12.4473 14.2649C12.9044 14.0031 13.4357 13.8859 13.963 13.9441C13.9628 13.9441 13.9632 13.9441 13.963 13.9441L15.0587 14.0634C15.0591 14.0635 15.0595 14.0635 15.0599 14.0636C15.262 14.0845 15.459 14.0473 15.6343 13.9549L15.6476 13.9481C15.8143 13.8651 15.9657 13.7202 16.0728 13.5349C16.1721 13.3633 16.2219 13.1533 16.211 12.9483C16.2002 12.7429 16.1289 12.5406 16.0107 12.382L16.0062 12.376L15.3506 11.4739C15.04 11.0387 14.8797 10.5238 14.8797 10.0001C14.8797 9.46777 15.0535 8.95842 15.3441 8.53554L15.3539 8.52166L16.0107 7.6181C16.1302 7.45775 16.2001 7.26382 16.211 7.05272L16.211 7.05186C16.2219 6.84686 16.1721 6.63685 16.0728 6.46523C15.9719 6.29064 15.8232 6.14641 15.6408 6.04872C15.4497 5.955 15.249 5.91702 15.0598 5.93661C15.0594 5.93665 15.0591 5.93669 15.0587 5.93673L13.9626 6.05611C13.4317 6.11357 12.8984 5.99938 12.4442 5.73351C11.983 5.46858 11.6241 5.0657 11.4149 4.58287L10.963 3.58109C10.8731 3.38603 10.7365 3.22632 10.5695 3.11721C10.4013 3.0073 10.2068 2.9488 9.99571 2.9488C9.79147 2.9488 9.5887 3.00821 9.4219 3.11721C9.25544 3.22598 9.11916 3.38504 9.02923 3.57927L8.58607 4.58062C8.3741 5.07111 8.00326 5.47075 7.55885 5.73173L7.55275 5.73531C7.09561 5.99705 6.5643 6.11425 6.03701 6.05607C6.03677 6.05604 6.03724 6.05609 6.03701 6.05607L4.94132 5.93673C4.94093 5.93669 4.94054 5.93665 4.94015 5.93661C4.73799 5.91564 4.54101 5.95285 4.36574 6.04524L4.35243 6.05206C4.18568 6.13509 4.03427 6.28 3.92717 6.46523C3.82794 6.63685 3.77814 6.84686 3.78897 7.05186C3.79983 7.25729 3.87111 7.45954 3.98928 7.61813L3.9938 7.6242L4.64464 8.51965C4.6449 8.52 4.64515 8.52035 4.64541 8.5207C4.96181 8.95293 5.1203 9.47122 5.1203 10.0001C5.1203 10.5324 4.94649 11.0417 4.65592 11.4646L4.64611 11.4785L3.9957 12.3733C3.87207 12.5476 3.79933 12.7473 3.78902 12.9474L3.78897 12.9483C3.77814 13.1533 3.82794 13.3633 3.92717 13.5349C4.02812 13.7095 4.1768 13.8538 4.3592 13.9514C4.55033 14.0452 4.75097 14.0831 4.94018 14.0636C4.94056 14.0635 4.94094 14.0635 4.94132 14.0634L6.03741 13.9441C6.56828 13.8866 7.10156 14.0008 7.5558 14.2666C7.99511 14.519 8.33782 14.8942 8.55643 15.3455ZM7.05996 10.0091C7.05996 8.38623 8.37353 7.06038 10.0041 7.06038C11.6346 7.06038 12.9482 8.38623 12.9482 10.0091C12.9482 11.632 11.6346 12.9578 10.0041 12.9578C8.37353 12.9578 7.05996 11.632 7.05996 10.0091ZM10.0041 8.34243C9.09394 8.34243 8.34748 9.08496 8.34748 10.0091C8.34748 10.9332 9.09394 11.6758 10.0041 11.6758C10.9142 11.6758 11.6607 10.9332 11.6607 10.0091C11.6607 9.08496 10.9142 8.34243 10.0041 8.34243Z"
                          fill="#1A1818"/>
                  </svg>
                  휴램프로 온보딩 가이드
                </Button>
              )
            }
            <Button
              type="line-gray"
              size="sm"
              style={{ columnGap: 10 }}
              onClick={() => window.open('https://shimmer-vein-8d5.notion.site/837bbffc98624ac78cac7cb92f72756d')}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M4.70542 2.5L5.06467 2.5C5.91129 2.5 6.58222 2.49999 7.12301 2.54384C7.67603 2.58867 8.14395 2.68222 8.57122 2.89825C9.15609 3.19396 9.64865 3.63837 10.0003 4.18327C10.352 3.63837 10.8446 3.19396 11.4294 2.89825C11.8567 2.68222 12.3246 2.58867 12.8776 2.54384C13.4184 2.49999 14.0894 2.5 14.936 2.5L15.2952 2.5C15.7093 2.49999 16.0549 2.49999 16.3373 2.52288C16.6318 2.54675 16.9082 2.59838 17.1697 2.73056C17.5708 2.93337 17.8969 3.25699 18.1013 3.65502C18.2345 3.91445 18.2865 4.1888 18.3106 4.48102C18.3337 4.7612 18.3337 5.10416 18.3337 5.51504V12.1773C18.3337 12.5882 18.3337 12.9311 18.3106 13.2113C18.2865 13.5035 18.2345 13.7779 18.1013 14.0373C17.8969 14.4353 17.5708 14.7589 17.1697 14.9617C16.9082 15.0939 16.6318 15.1456 16.3373 15.1694C16.0549 15.1923 15.7093 15.1923 15.2952 15.1923H14.2059C13.1989 15.1923 12.8166 15.1982 12.4781 15.3002C12.1612 15.3957 11.8664 15.5523 11.6105 15.7609C11.3372 15.9838 11.1202 16.2962 10.5616 17.1276L10.4841 17.2431C10.3762 17.4036 10.1947 17.5 10.0003 17.5C9.80593 17.5 9.62441 17.4036 9.51658 17.2431L9.43901 17.1276C8.88045 16.2962 8.66344 15.9838 8.39016 15.7609C8.13429 15.5523 7.83946 15.3957 7.52255 15.3002C7.18407 15.1982 6.80173 15.1923 5.79476 15.1923H4.7054C4.29133 15.1923 3.94572 15.1923 3.66337 15.1694C3.36889 15.1456 3.09241 15.0939 2.83097 14.9617C2.42985 14.7589 2.10372 14.4353 1.89934 14.0373C1.76613 13.7779 1.71411 13.5035 1.69005 13.2113C1.66698 12.9311 1.66698 12.5881 1.66699 12.1773V5.51505C1.66698 5.10416 1.66698 4.7612 1.69005 4.48102C1.71411 4.1888 1.76613 3.91445 1.89934 3.65502C2.10372 3.25699 2.42985 2.93337 2.83097 2.73056C3.09241 2.59838 3.36889 2.54675 3.66337 2.52288C3.94572 2.49999 4.29134 2.49999 4.70542 2.5ZM9.41893 8C9.41893 7.12886 9.41848 6.5102 9.37862 6.02606C9.33931 5.54866 9.2646 5.25308 9.14433 5.01887C8.90279 4.54847 8.51738 4.16601 8.04333 3.92633C7.8073 3.80699 7.50943 3.73286 7.02833 3.69385C6.54043 3.6543 5.91698 3.65385 5.03909 3.65385H4.72901C4.28527 3.65385 3.98742 3.6543 3.75806 3.67289C3.53548 3.69094 3.42906 3.72315 3.35886 3.75865C3.17653 3.85083 3.0283 3.99793 2.9354 4.17886C2.89963 4.24852 2.86716 4.35412 2.84898 4.57498C2.83024 4.80258 2.82978 5.09813 2.82978 5.53846V12.1538C2.82978 12.5942 2.83024 12.8897 2.84898 13.1173C2.86716 13.3382 2.89963 13.4438 2.9354 13.5135C3.0283 13.6944 3.17653 13.8415 3.35886 13.9337C3.42906 13.9692 3.53548 14.0014 3.75806 14.0194C3.98742 14.038 4.28527 14.0385 4.72901 14.0385H5.79476C5.82648 14.0385 5.8578 14.0385 5.88873 14.0384C6.76921 14.0383 7.33616 14.0381 7.86044 14.1961C8.32362 14.3357 8.75452 14.5645 9.12848 14.8695C9.23029 14.9526 9.32579 15.0427 9.41893 15.1419V8ZM10.5817 15.1419C10.6749 15.0427 10.7704 14.9526 10.8722 14.8695C11.2461 14.5645 11.677 14.3357 12.1402 14.1961C12.6645 14.0381 13.2314 14.0383 14.1119 14.0384C14.1429 14.0385 14.1742 14.0385 14.2059 14.0385H15.2716C15.7154 14.0385 16.0132 14.038 16.2426 14.0194C16.4652 14.0014 16.5716 13.9692 16.6418 13.9337C16.8241 13.8415 16.9724 13.6944 17.0653 13.5135C17.101 13.4438 17.1335 13.3382 17.1517 13.1173C17.1704 12.8897 17.1709 12.5942 17.1709 12.1538V5.53846C17.1709 5.09813 17.1704 4.80258 17.1517 4.57498C17.1335 4.35412 17.101 4.24852 17.0653 4.17886C16.9724 3.99793 16.8241 3.85083 16.6418 3.75865C16.5716 3.72315 16.4652 3.69094 16.2426 3.67289C16.0132 3.6543 15.7154 3.65385 15.2716 3.65385H14.9616C14.0837 3.65385 13.4602 3.6543 12.9723 3.69385C12.4912 3.73286 12.1934 3.80699 11.9573 3.92633C11.4833 4.16601 11.0979 4.54847 10.8563 5.01887C10.7361 5.25308 10.6613 5.54866 10.622 6.02606C10.5822 6.5102 10.5817 7.12886 10.5817 8V15.1419Z"
                      fill="#1A1818"/>
              </svg>
              휴램프로 사용 매뉴얼
            </Button>
            {author !== 'admin' ? <Link to="/hulamSetting">
              <SettingIcon/>
            </Link> : null}

            <Button type="text" onClick={() => {
              alert({
                type: 'confirm',
                icon: true,
                content: '로그아웃 하시겠습니까?',
                okText: '로그아웃하기',
                okButtonWidth: 100,
                onOk: logout
              })
            }}>
              <ExistIcon/>
            </Button>
          </Flex>
        </div>
      </div>
    </header>
  }

  return (
    <>
      {
        isLogin ?
          <ProgramHeader/> :
          <header>
            <HomepageHeader/>
          </header>
      }


    </>
  )
}
